import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import configurationClient from '@/axiosClients/configurationClient'

export const getCatalogBiologicalSexes = async ({ commit }, params = '') => {
    try {
        const { data: result } = await configurationClient.get(`/catalog/biological-sexes${params}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getNextBiologicalSexId = async ({ commit }) => {
    try {
        const { data: result } = await configurationClient.get(`/catalog/biological-sexes/next-id`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const storeCatalogBiologicalSex = async ({ commit }, payload) => {
    try {
        const { data: result } = await configurationClient.post(`/catalog/biological-sexes/catalog`, payload)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
